module.exports = __webpack_public_path__ + "img/1.f89b9519.jpg";